import i18next from 'i18next';
import { useState, useEffect, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Column } from 'react-table';
import TiassistoElement from '../../components/TiAssisto/TiassistoElement';

import toaster from '../../utils/toaster';
import Restricted from '../../components/Restricted/Restricted';
import VehicleTableContainer from '../../components/VehicleTable/VehicleTableContainer';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import { useApiClient } from '../../hooks/useApiClient';
import { useAuth } from '../../hooks/useAuth';
import { normalizeVehicleList } from '../../utils/vehicleList';
import { columnsData } from '../../components/VehicleTable/columnsData';
import { RoleEnum } from '../../api';

const MyFleetPage = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation()
  const { apiClient, handleApi } = useApiClient();
  const { userRole, user } = useAuth();

  const columns = useMemo(() => columnsData as Column<Object>[], []);
  const data = useMemo(() => response ?? [], [response]);

  useEffect(() => {
    handleApi(apiClient.vehicleController.getMyFleetVehiclesFilter())
      .then((res) => {
        // SORT FIRST VEHICLES IN STATE DISPONIBILE
        res.sort((a, b) => {
          if (a.stato_corrente.type === "DISPONIBILE" && b.stato_corrente.type !== "DISPONIBILE") {
            return -1;
          }
          if (b.stato_corrente.type === "DISPONIBILE" && a.stato_corrente.type !== "DISPONIBILE") {
            return 1;
          }
          return a.data_inserimento > b.data_inserimento ? -1 : b.data_inserimento > a.data_inserimento ? 1 : 0;
        });

        // normalize the vehicle list
        res = normalizeVehicleList(res);

        setResponse(res);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
        toaster.error(
          err.message || i18next.t('error_loading_data')
        );
      });

    return () => {
      // if (filter) {
      // 	sessionStorage.removeItem('vehicleAvailable-filters');
      // }
    }
  }, []);

  const filterIntialState = {
    stato_corrente: [],
    marca: [],
    stato_disp: [],
    modello: [],
    allestimento: [],
    city: [],
    data_disp: { from: '', to: '' },
    offerta_minima: { from: '', to: '' },
    carrozzeria: [],
    colore_esterno: [],
    colore_interno: [],
    telaio: '',
    data_immatricolazione: { from: '', to: '' },
    targa: '',
    alimentazione: '',
    cambio: '',
    trazione: [],
    nr_ordine: '',
    codice_costruttore: '',
    utente: '',
  };

  return (
    <Container fluid>
      <Row>
        <Col md={6} className="display-6">
          {t('my_fleet')}
        </Col>
        {/* //TODO reinstate the rescrtriction onf fleet manager */}
        <Restricted to={[RoleEnum.FLEET_MANAGER]}>
        <ErrorBoundary>
          <VehicleTableContainer
            columns={columns}
            data={data}
            hasFilters={true}
            filterIntialState={filterIntialState}
            loading={loading}
            error={error}
            hiddenColumns={['id']}
          ></VehicleTableContainer>
        </ErrorBoundary>
        </Restricted>
      </Row>
    </Container>

  )
}

export default MyFleetPage